module.exports = __webpack_public_path__ + "static/media/chain.92d6540f.svg";